import { SearchTerm } from "./SearchTerm";

const HoursWorkedReportSearch: SearchTerm[] = [
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "mstTitle",
        translationKey: "title"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName",
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "mstMiddlename",
        translationKey: "secondName",
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "mstLastname",
        translationKey: "lastName",
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        searchOnName: "mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Company",
        accessor: "company",
        searchOnName: "company.compName",
        translationKey: "company",
    },
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "department.deptName",
        translationKey: "department",
    },
    {
        heading: "Category",
        accessor: "category",
        searchOnName: "profile.trnName",
        translationKey: "category",
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site",
    },
]

export default HoursWorkedReportSearch;
